// extracted by mini-css-extract-plugin
export default {"subtitle":"PlanCardTitle_subtitle__25+X-","title":"PlanCardTitle_title__7ti-F"};